import { Directive, OnInit, OnChanges, AfterViewInit, SimpleChanges, Input, ElementRef, Renderer2, HostBinding, HostListener } from '@angular/core';

@Directive({
    selector: '[directive-side-collapse]',
})
export class SideCollapseSharedDirective implements OnInit, AfterViewInit, OnChanges {
    private _elem: HTMLElement;
    private _collapseSide: 'left' | 'right' = 'right';
    private _isMinimized: boolean;
    private _isAnimating: boolean = false;
    private _init: boolean = false;
    private _timeout: number = 300;
    private _transition: string = `all ${this._timeout / 1000}s ease`;

    @Input() public isCollapsed: boolean;

    constructor(
        private _elementRef: ElementRef,
        private _renderer2: Renderer2,
    ) { }

    ngOnInit(): void {
        this._elem = this._elementRef.nativeElement;

        if (this._elem.getAttribute('directive-side-collapse') !== 'right') {
            this._collapseSide = 'left';
        }
    }

    ngAfterViewInit(): void {
        this._init = true;
        this._initDirective();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (typeof this.isCollapsed !== 'boolean') return;

        if (changes.isCollapsed.previousValue !== this.isCollapsed) {
            this._initDirective();
        }
    }
    private _set(property: string, value: string | number = null): void {
        this._renderer2.setStyle(this._elem, property, value);
    }

    private _initDirective(): void {
        if (this.isCollapsed) {
            this._collapse();
        } else {
            this._expand();
        }
    }

    private _collapse(): void {
        if (!this._init) return;
        if (this._isMinimized === true) return;

        if (this._isMinimized === undefined) {
            this._set('overflow', 'hidden');
            this._set('transition', null);
            this._set('width', 0);

            this._isMinimized = true;

            return;
        }


        this._animate(this._elem.clientWidth, 0, true);

    }

    private _expand(): void {
        if (!this._init || this._isMinimized === false) return;
        if (this._isMinimized === undefined || this._isMinimized === null) {
            this._set('width');
            this._set('overflow');
            this._set('transition');

            this._isMinimized = false;
            return;
        }

        this._set('width');
        this._set('opacity', 0);
        this._set('overflow');
        this._set('transition');
        this._set('white-space');

        this._animate(0, this._elem.clientWidth, false);
    }

    private _animate(fromWidth: number, targetWidth: number, collapse: boolean = true): void {
        this._set('white-space', `nowrap`);
        this._set('opacity', collapse ? 1 : 0);
        this._set('width', `${fromWidth}px`);
        this._set('overflow', `hidden`);
        this._set('transition', this._transition);

        this._isAnimating = true;

        setTimeout(() => {
            this._set('width', `${targetWidth}px`);
            this._set('opacity', collapse ? 0 : 1);

            setTimeout(() => {
                this._isAnimating = false;
                this._isMinimized = collapse ? true : false;

                if (collapse) return;

                this._set('white-space');
                this._set('overflow');
                this._set('transition');
                this._set('width');
                this._set('opacity');

            }, this._timeout);
        }, 0);
    }
}
